import { PropsWithChildren, forwardRef } from 'react';
import Text from '~/components/typographies/Text';
import styles from './BuilderSection.module.scss';

interface Props {
  title: string;
}

const BuilderSection = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(({ children, title }, ref) => {
  return (
    <div className={styles.builderSection} ref={ref}>
      <Text variant="title4" weight="semibold">
        {title}
      </Text>
      {children}
    </div>
  );
});

export default BuilderSection;
